const routes = [
    {
        path: '/:lang',
        component: { render: h => h('router-view') },
        children: [
            {
                path: '',
                component: () => import('../layouts/MainLayout.vue'),
                children: [
                    {
                        path: '', component: () => import('../pages/index.vue'),
                    },
                    {
                        path: 'signin', component: () => import('../pages/signin.vue'),
                    },
                    // {
                    //     path: 'signup', component: () => import('../pages/signup.vue'),
                    // },
                    {
                        path: 'account',
                        meta: { requiresAuth: true },
                        component: { render: h => h('router-view') },
                        children: [
                            { path: '', component: () => import('../pages/account.index.vue') },
                            { path: 'change-password', component: () => import('../pages/account.change-password.vue') },
                            { path: 'profile', component: () => import('../pages/account.profile.vue') },
                        ]
                    },
                    { path: 'forget-password', component: () => import('../pages/forget-password.vue') },
                    { path: 'reset-password', component: () => import('../pages/reset-password.vue') },
                    {
                        path: 'admin',
                        meta: { requiresAuth: true },
                        component: { render: h => h('router-view') },
                        children: [
                            { path: '', component: () => import('../pages/admin.index.vue') },
                            {
                                path: 'users',
                                meta: { claims: ['user.read'] },
                                component: { render: h => h('router-view') },
                                children: [
                                    { path: '', component: () => import('../pages/admin.users.vue')},
                                    { path: ':id', component: () => import('../pages/admin.user.vue') },
                                    { path: ':id/roles', component: () => import('../pages/admin.user-roles.vue') },
                                ]
                            },
                            {
                                path: 'roles',
                                meta: { claims: ['role.read'] },
                                component: { render: h => h('router-view') },
                                children: [
                                    { path: '', component: () => import('../pages/admin.roles.vue') },
                                    { path: ':id', component: () => import('../pages/admin.role.vue') },
                                    { path: ':id/claims', component: () => import('../pages/admin.role-claims.vue') },
                                ]
                            },
                            { 
                                path: 'claims', component: () => import('../pages/admin.claims.vue') },
                            {
                                path: 'orders',
                                meta: { claims: ['order.read'] },
                                component: { render: h => h('router-view') },
                                children: [
                                    { path: '', component: () => import('../pages/admin.orders.vue') },
                                    { path: ':id', component: () => import('../pages/admin.order.vue') },
                                ]
                            },
                            {
                                path: 'contents',
                                meta: { claims: ['content.read'] },
                                component: { render: h => h('router-view') },
                                children: [
                                    { path: '', component: () => import('../pages/admin.contents.vue') },
                                    { path: ':id', component: () => import('../pages/admin.content.vue') },
                                ]
                            },
                        ]
                    },
                ]
            },
        ]
    },
    // Always leave this as last one,
    // but you can also remove it
    {
        path: '*',
        component: () => import('../pages/error-404.vue')
    }
];
export default routes















